/*** IMPORTS FROM imports-loader ***/
var define = false;

exports.f = require('./_wks');

